/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon20Light = forwardRef('CheckCircleCutIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.487 3.32a6.5 6.5 0 0 1 3.89-.043.5.5 0 1 0 .288-.958 7.5 7.5 0 1 0 5.258 8.257.5.5 0 0 0-.99-.144A6.5 6.5 0 1 1 7.487 3.32Z" }),
        React.createElement("path", { d: "M16.83 5.02a.5.5 0 1 0-.707-.708l-6.372 6.372a.984.984 0 0 1-1.392 0L5.994 8.32a.5.5 0 1 0-.707.707l2.365 2.364a1.985 1.985 0 0 0 2.806 0L16.83 5.02Z" })));
});
